import { Icon, Tooltip } from '@scuf/common';
import * as React from 'react';
import { Component } from 'react';

interface IHeaderProps {
  /** Widget title */
  title?: string;
  hoverEnabled?: boolean;
  /** Additional class */
  className?: string;
  tooltipContent?: string;
}

interface IHeaderState {
  showTooltip: boolean;
}

/**
 * A Widget can have one child Header component, which gets aligned at the top of the Widget.
 */

export default class Header extends Component<IHeaderProps, IHeaderState> {
  constructor(props: IHeaderProps) {
    super(props);
    this.state = {
      showTooltip: false
    };
  }

  render() {
    const {
      className,
      title,
      hoverEnabled,
      children,
      tooltipContent
    } = this.props;
    const controlsStyle = className
      ? `widget-controls ${className}`
      : 'widget-controls';
    return (
      <div className="widget-header">
        {title &&
          (hoverEnabled ? (
            <Tooltip
              element={
                <span
                  className="title"
                  onMouseOver={(e: any) =>
                    this.setState({
                      showTooltip: e.target.scrollWidth > e.target.clientWidth
                    })
                  }
                  onMouseOut={(e) => this.setState({ showTooltip: false })}
                >
                  {title}
                </span>
              }
              content={title}
              position="top left"
              event="hover"
              open={this.state.showTooltip}
            />
          ) : (
            <div>
              <span className="title">{title}</span>
              <span className="tooltip-badge-icon">
                {tooltipContent ? (
                  <Tooltip
                    element={<Icon name="badge-info" root="common" />}
                    content={tooltipContent}
                  />
                ) : (
                  ''
                )}
              </span>
            </div>
          ))}
        <div className={controlsStyle}>{children}</div>
      </div>
    );
  }
}
